import api from '@/services/Api';

export default {
  install({ shopname, code, timestamp, hmac }) {
    return api().post('/shoprenter/install', { shopname, code, timestamp, hmac });
  },

  auth({ shopname, code, timestamp, hmac }) {
    return api().post('/shoprenter/auth', { shopname, code, timestamp, hmac });
  },

  createCharge() {
    return api().post('/shoprenter/charge');
  },
};
